import ChannelDocumentsModal from './ChannelDocumentsModal';

export default ChannelDocumentsModal;
